export default __webpack_public_path__ + "static/Asset world corp_logo-c033c5d7a528d4e2313cfa3717802c13.png";